import { Injectable } from '@angular/core';
import {
  ACCESS_MATRIX,
  AccessAction,
  AccessKey,
  FEATURE_ACTION_MATRIX,
  FeatureActionKey,
  normalizeProfileCode
} from '../layouts/main-layout/components/sidebar/config/access-control.config';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  getAllowedKeys(profileCode: string | null): Set<AccessKey> {
    const normalized = normalizeProfileCode(profileCode);
    if (!normalized) {
      return new Set<AccessKey>();
    }
    return new Set<AccessKey>(ACCESS_MATRIX[normalized] ?? []);
  }

  hasAccess(profileCode: string | null, accessKey: AccessKey): boolean {
    const normalized = normalizeProfileCode(profileCode);
    if (!normalized) {
      return false;
    }
    return (ACCESS_MATRIX[normalized] ?? []).includes(accessKey);
  }

  hasFeatureActionAccess(profileCode: string | null, featureKey: FeatureActionKey, action: AccessAction, defaultValue = false): boolean {
    const normalized = normalizeProfileCode(profileCode);
    if (!normalized) {
      return false;
    }

    const actionMatrix = FEATURE_ACTION_MATRIX[featureKey];
    if (!actionMatrix) {
      return defaultValue;
    }

    const allowedProfiles = actionMatrix[action];
    if (!allowedProfiles) {
      return defaultValue;
    }

    return allowedProfiles.includes(normalized);
  }
}
